<template>
  <a-modal
    title="备注"
    :visible="visible"
    :confirm-loading="confirmLoading"
    :maskClosable="false"
    ok-text="保存"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <a-textarea
      v-model="remark"
      allowClear
      placeholder="请输入要备注的内容"
      :auto-size="{ minRows: 3, maxRows: 5 }"
    />
  </a-modal>
</template>

<script>
import { postEditFeedbackRemark } from '@/api/sale'

export default {
  data() {
    return {
      id: 0,
      remark: '',
      visible: false,
      confirmLoading: false
    }
  },
  methods: {
    showModal(id = 0, remark = '') {
      this.visible = true
      this.id = id
      this.remark = remark
    },
    handleOk(e) {
      this.postEdit()
    },
    handleCancel() {
      this.visible = false
    },
    // 编辑
    postEdit() {
      this.confirmLoading = true
      postEditFeedbackRemark({
        feedback_id: this.id,
        remark: this.remark
      })
        .then((res) => {
          if (res.code === 200) {
            this.$message.success('备注成功')
            this.visible = false
            this.$emit('ok')
          }
        })
        .catch((e) => {
          this.$message.error('备注失败')
        })
        .finally(() => {
          this.confirmLoading = false
        })
    }
  }
}
</script>
